export type Lang = "pl" | "en";

const translations: Record<string, Record<Lang, string>> = {
  title: { pl: "HolySheet", en: "HolySheet" },
  subtitle: { pl: "Optymalizator rozkroju materiałów", en: "Material cutting optimizer" },
  material: { pl: "Materiał", en: "Material" },
  stock_sheets: { pl: "Arkusze materiału", en: "Stock sheets" },
  required_pieces: { pl: "Elementy do wycięcia", en: "Required pieces" },
  add_stock: { pl: "+ Dodaj arkusz", en: "+ Add stock sheet" },
  add_piece: { pl: "+ Dodaj element", en: "+ Add piece" },
  width: { pl: "Szer.", en: "W" },
  height: { pl: "Wys.", en: "H" },
  quantity: { pl: "Ilość", en: "Qty" },
  label: { pl: "Nazwa", en: "Label" },
  cost: { pl: "Cena", en: "Cost" },
  kerf: { pl: "Szerokość rzazu", en: "Blade kerf" },
  allow_rotation: { pl: "Pozwól na obrót", en: "Allow rotation" },
  no_rotate: { pl: "Bez obrotu", en: "No rotate" },
  optimize: { pl: "Optymalizuj rozkrój", en: "Optimize cutting" },
  results: { pl: "Wyniki", en: "Results" },
  sheets_used: { pl: "Arkuszy użyto", en: "Sheets used" },
  waste: { pl: "Odpad", en: "Waste" },
  total_cost: { pl: "Łączny koszt", en: "Total cost" },
  unplaced_warning: { pl: "Nie udało się rozmieścić", en: "Could not place" },
  export_pdf: { pl: "Eksportuj PDF", en: "Export PDF" },
  sheet_nr: { pl: "Arkusz", en: "Sheet" },
  remove: { pl: "Usuń", en: "Remove" },
  footer: { pl: "Optymalizuj rozkrój, oszczędzaj materiał", en: "Optimize cuts, save material" },
  rotated: { pl: "obrócony", en: "rotated" },
  mm: { pl: "mm", en: "mm" },
  generated: { pl: "Wygenerowano", en: "Generated" },
  cut_list: { pl: "Lista elementów", en: "Cut list" },
  login: { pl: "Zaloguj", en: "Log in" },
  signup: { pl: "Rejestracja", en: "Sign up" },
  logout: { pl: "Wyloguj", en: "Log out" },
  email: { pl: "Email", en: "Email" },
  password: { pl: "Hasło", en: "Password" },
  no_account: { pl: "Nie masz konta?", en: "No account?" },
  has_account: { pl: "Masz już konto?", en: "Already have an account?" },
  stock_inventory: { pl: "Magazyn materiałów", en: "Stock inventory" },
  save_remnant: { pl: "Zapisz do magazynu", en: "Save to stock" },
  remnant_saved: { pl: "Zapisano resztkę", en: "Remnant saved" },
  remnant_badge: { pl: "resztka", en: "remnant" },
  use_from_stock: { pl: "Użyj z magazynu", en: "Use from stock" },
  save_project: { pl: "Zapisz projekt", en: "Save project" },
  load_project: { pl: "Wczytaj projekt", en: "Load project" },
  project_name: { pl: "Nazwa projektu", en: "Project name" },
  my_projects: { pl: "Moje projekty", en: "My projects" },
  saved: { pl: "Zapisano", en: "Saved" },
  delete: { pl: "Usuń", en: "Delete" },
  login_to_save: { pl: "Zaloguj się aby zapisywać", en: "Log in to save" },
  try_manual: { pl: "Spróbuj pobić", en: "Try to beat it" },
  reset_layout: { pl: "Resetuj", en: "Reset" },
  editing_layout: { pl: "Przeciągnij elementy aby zmienić układ", en: "Drag pieces to rearrange" },
};

export function t(key: string, lang: Lang): string {
  return translations[key]?.[lang] ?? key;
}
